import { ApplicationStatus } from 'api/applications/types'
import { ApplicationStatusSearchParam } from '../ApplicationList/types'

export const formatStatus = (status: ApplicationStatusSearchParam) =>
  status
    .split('-')
    .map((el) => el.replace(el[0], el[0].toUpperCase()))
    .join('') as ApplicationStatus
